export default __webpack_public_path__ + "static/bitdefender-561cc57cbc351d6cdf8757eb97f1745f.png";